var exports = {
  "W": "LogoMarquee__S2ns5t",
};

module.exports = exports;
